import { TAdFoxBannerSizeProps, getCompleteSizes } from '@cian/adfox-component';
import { makeContextModule } from '@cian/react-utils';

import { FC, JSX, useMemo } from 'react';

import { useAdfoxParameters } from './internal/hooks/useAdfoxParameters';
import { AdfoxContextData, PParams } from './types';

const contextData = makeContextModule<AdfoxContextData>({ contextName: 'AdfoxContextData' });

const {
  Context: { Provider },
} = contextData;

export const { useContext: useAdfoxContext, withContext: withAdfoxContext } = contextData;

export type AdfoxContextProviderProps = Omit<AdfoxContextData, 'params' | 'sizes'> & {
  children: JSX.Element | JSX.Element[];
  pParams: PParams;
  size: TAdFoxBannerSizeProps;
};

export const AdfoxContextProvider: FC<AdfoxContextProviderProps> = props => {
  const { children, pParams, size, postViewAnalyticsData } = props;

  const params = useAdfoxParameters(pParams);

  const contextValue = useMemo<AdfoxContextData>(
    () => ({ params, sizes: getCompleteSizes(size), postViewAnalyticsData }),
    [params, postViewAnalyticsData, size],
  );

  return <Provider value={contextValue}>{children}</Provider>;
};
